module.exports = __webpack_public_path__ + "img/web_nuevos1.065a9daa.png";